import React from 'react';
import noImage from '../../../../assets/images/no-image.png';

function SpecImage({ specTemplateData, isPageDisable, handleImageUpload, handleImageDelete, t }) {
  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('data:image/')) {
      imagePath = image;
    } else if (image) {
      imagePath = image;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };
  return (
    <div className="image-container mr-3">
      <div className="img">
        <img width="88" src={setImage(specTemplateData?.image)} alt="croppedImage" />
      </div>
      {!isPageDisable && (
        <div className="d-flex flex-column">
          <button aria-label="upload" className="btn btn-upload-img" onClick={() => handleImageUpload()} type="button">
            <span className="icon-upload" aria-hidden="true" title={t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')} />
          </button>
          <button aria-label="delete" className="btn btn-upload-img" onClick={() => handleImageDelete()} type="button">
            <span className="icon-delete" aria-hidden="true" title={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')} />
          </button>
        </div>
      )}
    </div>
  );
}

export default SpecImage;
